module.exports = __webpack_public_path__ + "static/media/windowscare.e3f2eecb.mp3";